import { getOverlayAlpha, alpha } from '@mui/material';
import type { Theme } from '@mui/material';

export function nthRowBackgroundImage(theme: Theme) {
    const rgba = alpha(
        theme.palette.mode === 'dark' ? '#fff' : '#000',
        parseFloat(getOverlayAlpha(1)),
    );

    return `linear-gradient(${rgba}, ${rgba})`;
}
